import {
    NgModule,
    LOCALE_ID,
    APP_INITIALIZER,
    CUSTOM_ELEMENTS_SCHEMA,
    ApplicationRef,
    OnInit,
} from '@angular/core';
import {NgMultiSelectDropDownModule} from 'ng-multiselect-dropdown';
//AuthGuard
import {AuthGuard} from './auth.guard';
//angular cdk
import {LayoutModule} from '@angular/cdk/layout';
//Custom routing module
import {appRouting} from './app.routing';

//import { PreBootService } from './Service/preboot.service'; //!important - Do Not move

//Angular modules
import {RouterModule} from '@angular/router';
import {BrowserModule} from '@angular/platform-browser';
import {
    ReactiveFormsModule,
    FormBuilder,
    FormGroup,
    Validators,
    FormsModule,
} from '@angular/forms';
import {
    CommonModule,
    DatePipe,
    CurrencyPipe,
    Location,
} from '@angular/common';
import {AgmCoreModule, Geocoder} from '@agm/core';
import {AgmDirectionModule} from 'agm-direction';
import {GooglePlaceModule} from 'ngx-google-places-autocomplete';

//Ngx-toastr
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {NgbDateStruct, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';

//Installed modules
import {OrderModule} from 'ngx-order-pipe';
import {NgxPaginationModule} from 'ngx-pagination';
import {NgxLoadingModule} from 'ngx-loading';
// import {FroalaEditorModule, FroalaViewModule} from 'angular-froala-wysiwyg';
import {CKEditorModule} from 'ng2-ckeditor';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ChartsModule} from 'ng2-charts';

//Components
import {AppComponent} from './app.component';
import {HomeComponent} from './home/home.component';

import {BusyComponent} from './busy/busy.component';
import {MenuComponent} from './menu/menu.component';

//Shared Components

//Message pop-up components
import {ConfirmComponent} from './popup/confirm.component';
import {AlertComponent} from './popup/alert.component';
import {PromptComponent} from './popup/prompt.component';
import {ParentDialogComponent} from './popup/parent-dialog.component';
import {ErrorComponent} from './popup/error.component';
import {CommentComponent} from './popup/comment.component';

import {ConfirmationPopoverModule} from 'angular-confirmation-popover';

//Service

import {GlobalsService} from './services/globals.service';
import {NavigationService} from './services/navigation.service';
import {AuthenticationService} from './services/authentication.service';
import {MenuService} from './services/menu.service';
import {PopupService} from './services/shared/popup.service';
import {VehicleMakeService} from './services/vehicle-make.service';
import {VehicleTypeService} from './services/vehicle-type.service';
import {FreightTypeService} from './services/freight-type.service';
import {StatusService} from './services/status.service';
import {UtilityServiceService} from './services/utility-service.service';
import {PermitTypeService} from './services/permit-type.service';
import {CarrierTypeService} from './services/carrier-type.service';
import {DocumentsServiceService} from './services/documents-service.service';
import {DocumenttypeService} from './services/documenttype.service';
import {CarrierTypeDocumentService} from './services/carrier-type-document.service';
import {ApplicationService} from './services/application.service';
import {VehicleService} from './services/vehicle.service';
import {PermitService} from './services/permit.service';
import {CarrierworkflowService} from './services/carrierworkflow.service';
import {WorkflowdashboardService} from './services/workflowdashboard.service';
import {RunMaintenanceTasksService} from './services/run-maintenance-tasks.service';
import {RunCorrespondenceTasksService} from './services/run-correspondence-tasks.service';
import {CarrierAccountService} from './services/carrier-account.service';
import {GooglePlacesSearchService} from './services/google-places-search.service';
import {PayGateService} from './services/paygate.service';

//Custom routing module

//Custom pipes
import {NoSanitizePipe} from './pipes/noSanitize.pipe';

import {VehicleTypeComponent} from './maintain/vehicle-type/vehicle-type.component';
import {ListVehicleTypeComponent} from './maintain/list-vehicle-type/list-vehicle-type.component';

import {ListVehicleMakeComponent} from './maintain/list-vehicle-make/list-vehicle-make.component';
import {VehicleMakeComponent} from './maintain/vehicle-make/vehicle-make.component';
import {PermitTypeComponent} from './maintain/permit-type/permit-type.component';
import {ListPermitTypeComponent} from './maintain/list-permit-type/list-permit-type.component';
import {ListStatusComponent} from './maintain/list-status/list-status.component';
import {StatusComponent} from './maintain/status/status.component';
import {ListCarrierTypeComponent} from './maintain/list-carrier-type/list-carrier-type.component';
import {CarrierTypeComponent} from './maintain/carrier-type/carrier-type.component';
import {AuthWebService} from './services/authweb.service';
import {LoginComponent} from './login/login.component';
import {StorageService} from './services/storage.service';
import {HttpClientModule} from '@angular/common/http';
import {RegisterComponent} from './register/register.component';
import {AmmenduserComponent} from './ammenduser/ammenduser.component';
import {CompanydetailsComponent} from './companydetails/companydetails.component';
import {CaLandingPageComponent} from './ca-landing-page/ca-landing-page.component';
import {EqualvalidatorDirective} from './validators/equalvalidator.directive';
import {ForgotComponent} from './forgot/forgot.component';
import {ResetComponent} from './reset/reset.component';
import {UsernameComponent} from './forgot/username/username.component';
import {UploaddocumentComponent} from './uploaddocument/uploaddocument.component';
import {ConfirmpasswordchangeComponent} from './reset/confirmpasswordchange/confirmpasswordchange.component';
import {ListDocumentTypeComponent} from './maintain/list-document-type/list-document-type.component';
import {DocumentTypeComponent} from './maintain/document-type/document-type.component';
import {CarrierService} from './services/carrier.service';
import {ManagementComponent} from './carrier-account/management/management.component';
import {CaContactPageComponent} from './ca-contact-page/ca-contact-page.component';

import {ComplianceLegalComponent} from './carrier-account/compliance-legal/compliance-legal.component';
import {TransportAssocService} from './services/transport-assoc.service';
import {PermitApplicationComponent} from './permits/permit-application/permit-application.component';
import {NewPermitApplicationComponent} from './permits/permit-application/new-permit-application/new-permit-application.component';
import {AppPermitTypeComponent} from './permits/permit-application/shared/app-permit-type/app-permit-type.component';
import {AppVehicleComponent} from './permits/permit-application/shared/app-vehicle/app-vehicle.component';
import {AppRouteComponent} from './permits/permit-application/shared/app-route/app-route.component';
import {AppMotivationComponent} from './permits/permit-application/shared/app-motivation/app-motivation.component';
import {AppUploadsComponent} from './permits/permit-application/shared/app-uploads/app-uploads.component';
import {CountryService} from './services/country.service';
import {SubmissionComponent} from './carrier-account/submission/submission.component';
import {ListCarrierTypeDocumentComponent} from './maintain/list-carrier-type-document/list-carrier-type-document.component';
import {CarrierTypeDocumentComponent} from './maintain/carrier-type-document/carrier-type-document.component';
import {ViewPermitApplicationComponent} from './permits/permit-application/view-permit-application/view-permit-application.component';
import {RecaptchaModule} from 'ng-recaptcha';
import {SideMenuComponent} from './side-menu/side-menu.component';
import {TransportAssociationComponent} from './maintain/transport-association/transport-association.component';
import {TransportAssociationListComponent} from './maintain/list-transport-association/transport-association-list.component';
import {WorkflowdashboardComponent} from './workflow/workflowdashboard/workflowdashboard.component';
import {PermitTypeDocumentComponent} from './maintain/permit-type-document/permit-type-document.component';
import {ListPermitTypeDocumentComponent} from './maintain/list-permit-type-document/list-permit-type-document.component';
import {ConfirmationComponent} from './permits/permit-application/shared/confirmation/confirmation.component';
import {ErrorsComponent} from './shared/errors/errors.component';

import {FooterBtnComponent} from './shared/footer-btn/footer-btn.component';

import {ActivateAccountComponent} from './activate-account/activate-account.component';
import {ApprovalManagerComponent} from './approval-manager/approval-manager.component';
import {PermitViewerComponent} from './application-approval/permit-viewer/permit-viewer.component';
import {CarrierViewerComponent} from './application-approval/carrier-viewer/carrier-viewer.component';
import {MotivationViewerComponent} from './application-approval/shared/motivation-viewer/motivation-viewer.component';
import {PermitTypeViewerComponent} from './application-approval/shared/permit-type-viewer/permit-type-viewer.component';
import {RouteViewerComponent} from './application-approval/shared/route-viewer/route-viewer.component';
import {UploadsViewerComponent} from './application-approval/shared/uploads-viewer/uploads-viewer.component';
import {VehicleViewerComponent} from './application-approval/shared/vehicle-viewer/vehicle-viewer.component';
import {ConfirmationViewerComponent} from './application-approval/shared/confirmation-viewer/confirmation-viewer.component';
import {PermitApprovalListComponent} from './approval-manager/permit-approval-list/permit-approval-list.component';
import {PermitCorrespondenceComponent} from './approval-manager/permit-correspondence/permit-correspondence.component';

import {PdfViewerModule} from 'ng2-pdf-viewer';
import {ManagerComponent} from './carrier-account/approve/manager/manager.component';
import {ListAccountsComponent} from './carrier-account/approve/list-accounts/list-accounts.component';

import {CarriercorrespondenceComponent} from './carrier-account/approve/carriercorrespondence/carriercorrespondence.component';
import {AddRouteComponent} from './maintain/route-management/add-route/add-route.component';
import {PrintingComponent} from './approval-manager/printing/printing.component';

import {ManageCountriesComponent} from './maintain/manage-countries/manage-countries.component';
import {AddNewPlaceComponent} from './maintain/add-new-place/add-new-place.component';
import {PlaceService} from './services/place.service';
import {ManageCountryPlacesComponent} from './maintain/manage-country-places/manage-country-places.component';
import {ListPermitTypeVehicleComponent} from './maintain/list-permit-type-vehicle/list-permit-type-vehicle.component';

import {ListRouteComponent} from './maintain/route-management/list-route/list-route/list-route.component';
import {PermitTypeVehicleService} from './services/permit-type-vehicle.service';
import {CorspdcService} from './services/corspdc.service';
import {CorspdcComponent} from './corspdc/corspdc.component';
import {PermitListApplicationComponent} from './permit-list-application/permit-list-application.component';
import {YesNoComponent} from './popup/yesno.component';
import {PermitCertificateReturnComponent} from './maintain/permit-certificate-return/permit-certificate-return.component';
import {RunMaintenanceTasksComponent} from './maintain/run-maintenance-tasks/run-maintenance-tasks.component';
import {BatchComponent} from './corspdc/batch/batch.component';
import {StatementComponent} from './carrier-account/statement/statement.component';
import {InvoiceComponent} from './carrier-account/statement/invoice/invoice.component';
import {RunCorrespondenceTasksComponent} from './maintain/run-correspondence-tasks/run-correspondence-tasks.component';
import {UnderConstructionComponent} from './permits/permit-application/shared/under-construction/under-construction.component';
import {DemographicsComponent} from './carrier-account/demographics/demographics.component';
import {ConsultantComponent} from './consultant/consultant.component';
import {CustomToastComponent} from './popup/custom-toast/custom-toast.component';
import {RenewPermitComponent} from './permits/permit-application/renew-permit/renew-permit.component';
import {NgxIntlTelInputModule} from './shared/projects/ngx-intl-tel-input/src/lib/ngx-intl-tel-input.module';
import {AssignRolePopupComponent} from './consultant/popups/assign-role-popup.component';
import {LinkCarrierAccountComponent} from './carrier-account/link-carrier-account/link-carrier-account.component';
import {DeLinkCarrierAccountComponent} from './carrier-account/delink-carrier-account/delink-carrier-account.component';
import {EnterOtpPopupComponent} from './carrier-account/link-carrier-account/enter-otp-popup/enter-otp-popup.component';
import {
    EnterConfirmationPopupComponent
} from './carrier-account/delink-carrier-account/enter-confirmation-popup/enter-confirmation-popup.component';
import {TimetableService} from './services/timetable.service';
import {ManageComponent} from './permits/permit-application/timetable/manage/manage.component';
import {ExtractViewsComponent} from './extract-views/extract-views/extract-views.component';
import {RunExtractsComponent} from './extract-views/extract-views/run-extracts/run-extracts.component';
import {AddDataExtractComponent} from './extract-views/extract-views/add-data-extract/add-data-extract.component';
import {TimetableComponent} from './permits/permit-application/timetable/timetable.component';
import {CustomTimeZonePipe} from './pipes/custom-time-zone.pipe';
import {FooterComponent} from './carrier-account/statement/footer/footer.component';
import {CarriertransactionService} from './services/carriertransaction.service';
import {FooterStatmentComponent} from './carrier-account/statement/footer-statment/footer-statment.component';
import {IdleManagerService} from './services/idle-manager.service';
import {NgIdleKeepaliveModule} from '@ng-idle/keepalive';
import {MomentModule} from 'angular2-moment';
import {ModalModule} from 'ngx-bootstrap/modal';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {ViewPermitComponent} from './maintain/view-permit/view-permit.component';
import {ManageVehiclesComponent} from './maintain/manage-vehicles/manage-vehicles.component';
import {VehicleEntryService} from './services/vehicle-entry.service';
import {VehicleEntryCarrierService} from './services/vehicle-entry-carrier.service';
import {TableModule} from 'primeng/table';
import {ExternalVehiclesComponent} from './maintain/external-vehicles/external-vehicles.component';
import {CarrierDetailsComponent} from './permits/permit-application/shared/carrier-details/carrier-details.component';
import {CalendarViewerComponent} from './shared/calendar-viewer/calendar-viewer.component';
import {TripComponent} from './shared/calendar-viewer/trip/trip.component';
import {FileDropModule} from 'ngx-file-drop';
import {ListFreightTypeComponent} from './maintain/list-freight-type/list-freight-type.component';
import {EditFreightTypeComponent} from './maintain/edit-freight-type/edit-freight-type.component';
import {CarrierComplianceListComponent} from './compliance/carrier-compliance-list/carrier-compliance-list.component';
import {CompliancereturnsService} from './services/compliancereturns.service';
import {SessionService} from './services/session.service';

import {CalendarService} from './services/calendar.service';
import {SupportComponent} from './support/support.component';
import {ComplianceApplicationComponent} from './compliance/compliance-application/compliance-application.component';
import {ComplianceReturnListComponent} from './compliance/compliance-return-list/compliance-return-list.component';
import {MonthlyComplianceListComponent} from './monthly-compliance/monthly-compliance-list/monthly-compliance-list.component';
import {ComplianceDetailsComponent} from './compliance/compliance-details/compliance-details.component';
import {CConfirmationComponent} from './compliance/confirmation/c-confirmation.component';
import {SharedModule} from './shared.module';
//PAYGATE
import {AccountDepositComponent} from './PayGate/accountDeposit.component';
import {PaymentCompleteComponent} from './PayGate/PaymentComplete/paymentComplete.component';

import {PdfJsViewerModule} from 'ng2-pdfjs-viewer';
import {BootstrapModalModule, DialogService} from 'ng2-bootstrap-modal';
import {ConfirmDialogModule} from './services/shared/confirm-dialog/confirm-dialog.module';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {MsalModule, MsalService, MSAL_INSTANCE} from '@azure/msal-angular';
import {
    IPublicClientApplication,
    PublicClientApplication,
} from '@azure/msal-browser';

//import { HttpInterceptor } from '@angular/common/http';

//Custom pre-boot service
// export function prebootServiceFactory(prebootService: PreBootService): Function {
//     return () => prebootService.load();
// }

import {
    FacebookLoginProvider,
    GoogleLoginProvider,
    SocialAuthService,
    SocialAuthServiceConfig,
    SocialLoginModule,
} from 'angular12-social-login';
import {SocialUser} from 'angular12-social-login';
import {environment} from 'environments/environment';
import {FacebookpolicyComponent} from './facebookpolicy/facebookpolicy.component';
import {ListSessionComponent} from './maintain/list-session/list-session.component';
import {AddScannerComponent} from './maintain/add-scanner/add-scanner.component';
import {ListScannerComponent} from './maintain/list-scanner/list-scanner.component';
import {CarrierStepperComponent} from './carrier-stepper/carrier-stepper.component';
import { InjectionToken } from '@angular/core';

import {CredentialResponse, PromptMomentNotification} from 'google-one-tap';
import {SupportNewComponent} from './support-new/support-new.component';
import {CarrierDocumentsComponent} from './carrier-documents/carrier-documents.component';
import {ResendRegistrationComponent} from './resend-registration/resend-registration.component';
// import { StepperComponent } from './stepper/stepper.component';
//import { StepperComponent } from "./shared/stepper/stepper/stepper.component";
//import { StepperContainerComponent } from "./shared/stepper/stepper-container/stepper-container.component";
import {CarrierCongratulationsComponent} from './carrier-congratulations/carrier-congratulations.component';
import {FileDragNDropDirective} from './maintain/manage-vehicles/file-drag-n-drop';
import {PermitStepperComponent} from './permits/permit-application/permit-stepper/permit-stepper.component';
import {CaLandingPageNoaccountComponent} from './ca-landing-page-noaccount/ca-landing-page-noaccount.component';
import {PermitCongratulationsComponent} from './permit-congratulations/permit-congratulations.component';
import {QuillModule} from 'ngx-quill';
import {TestingComponent} from './testing/testing.component';
import {AlphabetOnlyDirective} from './alphabet-only.directive';
import {DocumentViewerComponent} from './shared/document-viewer/document-viewer.component';
import {FilterComponent} from './shared/filter/filter.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {SubsidiaryListCompaniesComponent} from './carrier-account/subsidiary-list-companies/subsidiary-list-companies.component';
import {ModifyDetailsComponent} from './application-approval/shared/modify-details/modify-details.component';
import {ModifyRouteComponent} from './application-approval/shared/modify-route/modify-route.component';
import {FilterModule} from './shared/filter/filter.module';
import {ExtRouteListComponent} from './maintain/route-management/ext-route-list/ext-route-list.component';
import {RouteService} from './services/route.service';
import {ToastNotificationComponent} from './shared/toast-notification/toast-notification.component';
import {ToastNotificationService} from './shared/toast-notification/toast-notification.service';
import {ActionsModule} from './shared/actions/actions.module';
import {ProgressComponent} from './shared/progress/progress.component';
import {PermitTimetableComponent} from './permits/permit-application/permit-timetable/permit-timetable.component';
import {FileDetailsPipe} from './pipes/file-details/file-details.pipe';
import {ProgressModule} from './shared/progress/progress.module';
import {DocumentViewerModule} from './shared/document-viewer/document-viewer.module';
import {CarrierDepotService} from './carrier-depot/service/carrier-depot.service';
import {DisplayQuestionnaireModule} from './ocas/display-questionnaire/display-questionnaire.module';
import {DisplayCarrierDriverModule} from './carrier-driver/display-carrier-driver/display-carrier-driver.module';
import {DisplayCarrierDepotModule} from './carrier-depot/display-carrier-depot/display-carrier-depot.module';
import {DisplayManageVehiclesModule} from './maintain/manage-vehicles/display-manage-vehicles/display-manage-vehicles.module';
import {RouteViewerMapComponent} from './maintain/route-management/route-viewer-map/route-viewer-map.component';
import {OcasStepperComponent} from './ocas-stepper/ocas-stepper.component';
import {CarrierDepotListModule} from './carrier-depot/carrier-depot-list/carrier-depot-list.module';
import {CarrierDriverListModule} from './carrier-driver/carrier-driver-list/carrier-driver-list.module';
import {QuestionnaireModule} from './ocas/questionnaire/questionnaire.module';
import {OcasAuditModule} from './ocas-audit/ocas-audit.module';
import {BusyModule} from './busy/busy.module';
import {CurrencyFormatModule} from './pipes/currency-format/currency-format.module';
import {ComplianceprocessesComponent} from './annual-compliance/complianceprocesses/complianceprocesses.component';
import {NewPermitStepperComponent} from './new-permit-stepper/new-permit-stepper.component';
import {PermitTypeDocumentService} from 'app/services/permit-type-document.service';
import {PassengerPermitsComponent} from './monthly-compliance/passenger-permits/passenger-permits.component';
import {MonthlyComplianceService} from './services/monthly-compliance.service';
import { WFStatusComponent } from './workflow/admin/wfstatus/wfstatus.component';
import { WFRoutesComponent } from './workflow/admin/wfroutes/wfroutes.component';
import { WFRouteTypeComponent } from './workflow/admin/wfroute-type/wfroute-type.component';
import { WFActionsComponent } from './workflow/admin/wfactions/wfactions.component';
import { DashboardComponent } from './workflow/management/dashboard/dashboard.component';
import { ProcesstrackingComponent } from './workflow/processtracking/processtracking.component';
import { ProcessviewComponent } from './workflow/processview/processview.component';
import { MyinboxComponent } from './workflow/myinbox/myinbox.component';
import { ProcessComponent } from './workflow/process/process.component';
import { ViewannualcomplianceComponent } from './workflow/processview/viewannualcompliance/viewannualcompliance.component';
import { ReportsForSanralComponent } from './powerbireports/reports-for-sanral/reports-for-sanral.component';
import { ReportsForAdminComponent } from './powerbireports/reports-for-admin/reports-for-admin.component';

import {CarrierReportsComponent} from './powerbireports/carrier-reports/carrier-reports.component';
import {ReportsComponent} from './powerbireports/reports/reports.component';
import { PowerBIEmbedModule } from 'powerbi-client-angular';
import { PassengerListComponent } from "./compliance/passenger-list/passenger-list.component";
import { AdminMonthlyComplianceComponent } from "./monthly-compliance/admin-monthly-compliance/admin-monthly-compliance.component";
import { PassengerListServiceService } from './services/passenger-list-service.service';
import { ImportService } from './services/import.service';
import {CarrierDriverAddModule} from './carrier-driver/carrier-driver-add/carrier-driver-add.module';
import { WfdelegationComponent } from './workflow/admin/wfdelegation/wfdelegation.component';
import { WfescalationComponent } from './workflow/admin/wfescalation/wfescalation.component';
import { ListGazettesComponent } from './gazetting/list-gazettes/list-gazettes.component';
import { ViewEditGazettesComponent } from './gazetting/view-edit-gazettes/view-edit-gazettes.component';
import { SelectApplicationsComponent } from './gazetting/select-applications/select-applications.component';
import { UnassignedComponent } from './workflow/unassigned/unassigned.component';
import { WfmanageactivityComponent } from './workflow/management/wfmanageactivity/wfmanageactivity.component';

// let gapiClientConfig: NgGapiClientConfig = {
//   client_id: "42235825666-vl4kgsvsl4lvh7986v1dl2ifspe351tk.apps.googleusercontent.com",
//   discoveryDocs: ["https://analyticsreporting.googleapis.com/$discovery/rest?version=v4"],
//   ux_mode: "redirect",
//   redirect_uri: "https://ng-gapi-example.stackblitz.io/redirect",
//   scope: [
//       "https://www.googleapis.com/auth/userinfo.profile"
//   ].join(" ")
// };

const fbLoginOptions = {
    scope:
        'pages_messaging,pages_messaging_subscriptions,email,pages_show_list,manage_pages',
    return_scopes: true,
    enable_profile_selector: true,
}; // https://developers.facebook.com/docs/reference/javascript/FB.login/v2.11

const googleLoginOptions = {
    scope: 'profile email',
    plugin_name: 'login',
    cookiepolicy: 'single_host_origin',
}; // https://developers.google.com/api-client-library/javascript/reference/referencedocs#gapiauth2clientconfig

const vkLoginOptions = {
    fields: 'photo_max,contacts', // Profile fields to return, see: https://vk.com/dev/objects/user
    version: '5.124', // https://vk.com/dev/versions
}; // https://vk.com/dev/users.get

export function socialConfigs() {
    const config = [
        {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider('502819838047618', fbLoginOptions),
        },
        {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
                '42235825666-vl4kgsvsl4lvh7986v1dl2ifspe351tk.apps.googleusercontent.com',
                googleLoginOptions
            ),
        },
    ];
    return config;
}

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication({
        auth: {
            clientId: 'd6b2061d-8857-41e0-a99d-a3578b390e59',
            redirectUri: environment.azure.redirectUri,
        },
    });
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MenuComponent,
    // BusyComponent,
    // ProgressComponent,
    //Share Components
    //Popup Components
    ConfirmComponent,
    AlertComponent,
    PromptComponent,
    ParentDialogComponent,
    YesNoComponent,
    ErrorComponent,
    AlphabetOnlyDirective,
    CommentComponent,
    NoSanitizePipe,
    VehicleTypeComponent,
    ReportsForAdminComponent,
    ListVehicleTypeComponent,
    ListVehicleMakeComponent,
    VehicleMakeComponent,
    PermitTypeComponent,
    ListPermitTypeComponent,
    ListStatusComponent,
    StatusComponent,
    ListCarrierTypeComponent,
    CConfirmationComponent,
    CarrierTypeComponent,
    LoginComponent,
    ReportsComponent,
    RegisterComponent,
    AmmenduserComponent,
    CompanydetailsComponent,
    ReportsForSanralComponent,
    CaLandingPageComponent,
    EqualvalidatorDirective,
    ForgotComponent,
    ResetComponent,
    UsernameComponent,
    ManagementComponent,
    UploaddocumentComponent,
    ConfirmpasswordchangeComponent,
    ListDocumentTypeComponent,
    DocumentTypeComponent,
    ComplianceLegalComponent,
    SubmissionComponent,
    DocumentTypeComponent,
    ListCarrierTypeDocumentComponent,
    CarrierTypeDocumentComponent,
    //
    ResetComponent,
    UsernameComponent,
    ManagementComponent,
    UploaddocumentComponent,
    ConfirmpasswordchangeComponent,
    CaContactPageComponent,
    PermitApplicationComponent,
    NewPermitApplicationComponent,
    AppPermitTypeComponent,
    AppVehicleComponent,
    AppRouteComponent,
    AppMotivationComponent,
    AppUploadsComponent,
    ViewPermitApplicationComponent,
    SideMenuComponent,
    TransportAssociationComponent,
    TransportAssociationListComponent,
    WorkflowdashboardComponent,
    PermitTypeDocumentComponent,
    ListPermitTypeDocumentComponent,
    ConfirmationComponent,
    ErrorsComponent,
    ActivateAccountComponent,
    ApprovalManagerComponent,
    FooterBtnComponent,
    PermitViewerComponent,
    CarrierViewerComponent,
    MotivationViewerComponent,
    PermitTypeViewerComponent,
    RouteViewerComponent,
    UploadsViewerComponent,
    VehicleViewerComponent,
    ConfirmationViewerComponent,
    PermitApprovalListComponent,
    PermitCorrespondenceComponent,
    ManagerComponent,
    ListAccountsComponent,
    CarriercorrespondenceComponent,
    AddRouteComponent,
    PrintingComponent,
    ManageCountriesComponent,
    AddNewPlaceComponent,
    ListRouteComponent,
    ManageCountriesComponent,
    ManageCountryPlacesComponent,
    ListPermitTypeVehicleComponent,
    CorspdcComponent,
    PermitListApplicationComponent,
    PermitCertificateReturnComponent,
    RunCorrespondenceTasksComponent,
    RunMaintenanceTasksComponent,
    UnderConstructionComponent,
    BatchComponent,
    CustomToastComponent,
    StatementComponent,
    InvoiceComponent,
    DemographicsComponent,
    ConsultantComponent,
    InvoiceComponent,
    RenewPermitComponent,
    AssignRolePopupComponent,
    LinkCarrierAccountComponent,
    DeLinkCarrierAccountComponent,
    EnterOtpPopupComponent,
    EnterConfirmationPopupComponent,
    TimetableComponent,
    ManageComponent,
    CustomTimeZonePipe,
    ExtractViewsComponent,
    RunExtractsComponent,
    AddDataExtractComponent,
    FooterComponent,
    FooterStatmentComponent,
    MonthlyComplianceListComponent,
    ViewPermitComponent,
    ManageVehiclesComponent,
    ExternalVehiclesComponent,
    CarrierDetailsComponent,
    CalendarViewerComponent,
    TripComponent,
    ListFreightTypeComponent,
    EditFreightTypeComponent,
    CarrierComplianceListComponent,
    ComplianceDetailsComponent,
    ComplianceReturnListComponent,
    ComplianceApplicationComponent,
    SupportComponent,
    //Paygate
    AccountDepositComponent,
    PaymentCompleteComponent,
    FacebookpolicyComponent,
    ListSessionComponent,
    AddScannerComponent,
    ListScannerComponent,
    CarrierStepperComponent,
    SupportNewComponent,
    CarrierDocumentsComponent,
    ResendRegistrationComponent,
    //StepperComponent,
    //StepperContainerComponent,
    CarrierCongratulationsComponent,
    FileDragNDropDirective,
    PermitStepperComponent,
    CaLandingPageNoaccountComponent,
    PermitCongratulationsComponent,
    TestingComponent,
    // DocumentViewerComponent,
    SubsidiaryListCompaniesComponent,
    ModifyDetailsComponent,
    ModifyRouteComponent,
    ExtRouteListComponent,
    ToastNotificationComponent,
    // ProgressComponent,
    PermitTimetableComponent,
    RouteViewerMapComponent,
    OcasStepperComponent,
    NewPermitStepperComponent,
    PassengerPermitsComponent,
    WFStatusComponent,
    WFRoutesComponent,
    WFRouteTypeComponent,
    WFActionsComponent,
    DashboardComponent,
    ProcesstrackingComponent,
    ProcessviewComponent,
    MyinboxComponent,
    ProcessComponent,
    CarrierReportsComponent,
    PassengerListComponent,
    AdminMonthlyComplianceComponent,
    ViewannualcomplianceComponent,
    WfdelegationComponent,
    WfescalationComponent,
    ListGazettesComponent,
    ViewEditGazettesComponent,
    SelectApplicationsComponent,
    UnassignedComponent,
    WfmanageactivityComponent
  ],
  bootstrap: [AppComponent],
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        ReactiveFormsModule,
        ConfirmDialogModule,
        DragDropModule,
        TableModule,
        PdfViewerModule,
        PdfJsViewerModule,
        BrowserModule.withServerTransition({appId: 'ng-cli-universal'}),
        LayoutModule,
        HttpClientModule,
        OrderModule,
        PowerBIEmbedModule,
        AgmCoreModule.forRoot({
            apiKey: environment.APIKey.TempKey,
            libraries: ['places'],
        }),
        AgmDirectionModule,
        GooglePlaceModule,
        // BootstrapModalModule,
        ReactiveFormsModule,
        NgxPaginationModule,
        NgxLoadingModule.forRoot({}),
        appRouting,
        // FroalaEditorModule.forRoot(),
        // FroalaViewModule.forRoot(),
        ConfirmationPopoverModule.forRoot({
            confirmButtonType: 'danger', // set defaults here
        }),
        QuillModule.forRoot(),
        CKEditorModule,
        NgbModule,
        RecaptchaModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            disableTimeOut: true,
            tapToDismiss: false,
            positionClass: 'toast-center-center',
            closeButton: true,
            preventDuplicates: true,
            maxOpened: 1,
        }),
        NgMultiSelectDropDownModule.forRoot(),
        NgxIntlTelInputModule,
        NgIdleKeepaliveModule.forRoot(),
        MomentModule,
        ModalModule.forRoot(),
        FileDropModule,
        NgxExtendedPdfViewerModule,
        SocialLoginModule,
        MsalModule,
        TabsModule.forRoot(),
        FilterModule,
        ActionsModule,
        ProgressModule,
        DocumentViewerModule,
        DisplayQuestionnaireModule,
        DisplayCarrierDriverModule,
        DisplayCarrierDepotModule,
        DisplayManageVehiclesModule,
        CarrierDepotListModule,
        CarrierDriverListModule,
        QuestionnaireModule,
        OcasAuditModule,
        BusyModule,
        //currency
        CurrencyFormatModule,
        CarrierDriverAddModule
    ],
  exports:[
    //StepperContainerComponent,
   // StepperComponent,
  ],
  providers: [
    AuthGuard,
    // { provide: Http, useClass: ExtendedHttpService },
    // PreBootService,
    // {
    //     provide: APP_INITIALIZER,
    //     useFactorcay: prebootServiceFactory,
    //     deps: [PreBootService],
    //     multi: true
    // },
    // DialogService,
    DatePipe,
    CurrencyPipe,
    GlobalsService,
    NavigationService,
    NavigationService,
    AuthenticationService,
    MenuService,
    PopupService,
    StatusService,
    VehicleTypeService,
    FreightTypeService,
    VehicleMakeService,
    UtilityServiceService,
    PermitTypeService,
    CarrierTypeService,
    AuthWebService,
    StorageService,
    CarrierService,
    DocumentsServiceService,
    DocumenttypeService,
    TransportAssocService,
    CountryService,
    PlaceService,
    CarrierTypeDocumentService,
    ApplicationService,
    PayGateService,
    VehicleService,
    PermitService,
    CarrierworkflowService,
    WorkflowdashboardService,
    PermitTypeVehicleService,
    CorspdcService,
    RunMaintenanceTasksService,
    RunCorrespondenceTasksService,
    CarrierAccountService,
    TimetableService,
    CarriertransactionService,
    IdleManagerService,
    GooglePlacesSearchService,
    VehicleEntryService,
    VehicleEntryCarrierService,
    CompliancereturnsService,
    CalendarService,
    SessionService,
    RouteService,
    CarrierDepotService,
    FileDetailsPipe,
    MonthlyComplianceService,
    PermitTypeDocumentService,
    PassengerListServiceService,
    ImportService,
    {
      provide: LOCALE_ID,
      useValue: "en-ZA",
    },
    {
      provide: "SocialAuthServiceConfig",
      useValue: {
        autoLogin: false,
        prompt: "select_account",
        providers: [
          {
            id: FacebookLoginProvider.PROVIDER_ID,
            provider: new FacebookLoginProvider("502819838047618"),
          },
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              "922769349816-o4sujaq5m0gs033ilvneqj8taffa71qs.apps.googleusercontent.com",
              googleLoginOptions
            ),
          },
        ],
        onError: (err) => {
          console.error(err);
        },
      } as SocialAuthServiceConfig,
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: MSALInstanceFactory,
    },
    MsalService,
  ],
})
export class AppModule implements OnInit {
    user: SocialUser | undefined;
    loggedIn: boolean | undefined;

    constructor(
        private authService: SocialAuthService,
        applicationRef: ApplicationRef
    ) {
        Object.defineProperty(applicationRef, '_rootComponents', {
            get: () => applicationRef['components'],
        });
    }

    ngOnInit(): void {
        this.authService.authState.subscribe((user) => {
            this.user = user;
            this.loggedIn = user != null;
        });
    }

    //   constructor(applicationRef: ApplicationRef) {
    //     //for ng2-bootstrap-modal in angualar 5
    //     Object.defineProperty(applicationRef, '_rootComponents', { get: () => applicationRef['components'] });
    //   }
}
